import type { IFetchService } from "app/services/fetchService";

import type { AccountManagerInfo, AccountManagers } from "../types";

const ACCOUNT_MANAGERS_PATH = "/sales-api/account-managers";

type AccountManagerInfoResponse = {
    exists: boolean;
    chiliPiperSlug?: string;
};

type AccountManagersResponse = {
    accountManager: AccountManagerInfoResponse | null;
    accountSuccessManager: AccountManagerInfoResponse | null;
};

const toAccountManagerInfo = (
    response: AccountManagerInfoResponse | null | undefined,
): AccountManagerInfo | null => {
    if (!response?.exists || !response.chiliPiperSlug) {
        return null;
    }

    return { chiliPiperSlug: response.chiliPiperSlug };
};

export const createAccountManagerApiService = (fetchService: IFetchService) => ({
    fetchAccountManagers: async (): Promise<AccountManagers> => {
        const response = await fetchService.get<AccountManagersResponse>(ACCOUNT_MANAGERS_PATH, undefined);

        return {
            accountManager: toAccountManagerInfo(response?.accountManager),
            accountSuccessManager: toAccountManagerInfo(response?.accountSuccessManager),
        };
    },
});
